import { Sector } from './Sector';

export default Sector;
